package com.schoolconnect.app.repository.systemlookup

import com.schoolconnect.app.datasource.network.response.LookupItemResponse

/** UI-facing accessors for generic lookup metadata. */
object SystemLookupOptions {
    fun activeItems(category: String): List<LookupItemResponse> =
        SystemLookupRepository.activeValues(category)

    fun codes(category: String): List<String> =
        activeItems(category).mapNotNull { it.code?.trim()?.takeIf(String::isNotBlank) }

    fun labels(category: String): List<String> =
        activeItems(category).mapNotNull {
            (it.displayValue ?: it.code)?.trim()?.takeIf(String::isNotBlank)
        }

    fun label(category: String, code: String): String =
        SystemLookupRepository.value(category, code)?.displayValue
            ?.trim()
            ?.takeIf(String::isNotBlank)
            ?: code

    fun code(category: String, displayValue: String): String =
        activeItems(category).firstOrNull {
            it.displayValue.equals(displayValue.trim(), ignoreCase = true) ||
                it.code.equals(displayValue.trim(), ignoreCase = true)
        }?.code.orEmpty()

    /**
     * Converts a UI value to the protocol value owned by the backend.
     *
     * Forms commonly hold display labels (for example, "Male"), while the
     * API expects the lookup code (for example, "M"). Never fall back to the
     * label here: an unmapped value means the lookup data is unavailable or
     * stale and the request must not be sent with a guessed constant.
     */
    fun serverCode(category: String, value: String): String {
        val normalized = value.trim()
        if (normalized.isBlank()) return ""
        return code(category, normalized).ifBlank {
            throw IllegalStateException(
                "Server constant '$normalized' was not found in lookup category '${category.trim()}'."
            )
        }
    }
}
